import React, { Component } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

import '../../../assets/styles/components/_collapse.scss';
import '../../../assets/styles/components/_content-tabs.scss';

class ModalValIncomeContent extends Component {

  constructor(props) {
    super(props)
    this.state = {
    }
  }

  render(props) {
    return (
      <div>
        <fieldset>
          <Tabs defaultIndex={0} onSelect={index => console.log(index)} className="p-t-spacer-2">
            <div className="d-flex align-center flex-space-between">
              <TabList className="content-tabs">
                <Tab className="button-tab" selectedClassName="active">По вещам</Tab>
                <Tab className="button-tab" selectedClassName="active">По подразделениям</Tab>
                <Tab className="button-tab" selectedClassName="active">Фактический</Tab>
              </TabList>
              <div className="m-l-spacer-3">
                <div className="form-element">
                  <label className="form-element-label" htmlFor="#">Касса</label>
                  <div className="form-element-data">
                    <select className="input">
                      <option>Выберите…</option>
                      <option>МН16</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <TabPanel>
              <div className="content-datatable-content p-l-spacer-2 p-r-spacer-2">
                <table className="table hover">
                  <thead>
                    <tr>
                      <th colSpan="2"></th>
                      <th scope="col" colSpan="2">Выдано микроаймов</th>
                      <th scope="col" colSpan="2">Просрочки</th>
                      <th scope="col" colSpan="2">Продление</th>
                      <th scope="col" colSpan="2">Перерасчёт</th>
                      <th scope="col" colSpan="2">Сторно при выкупе</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <span className="text-muted">№ П/П</span>
                      </td>
                      <td>
                        <span className="text-muted">Дата</span>
                      </td>
                      <td>
                        <span className="caption">Выдано микроаймов</span>
                        <p>Проценты по микрозайму</p>
                      </td>
                      <td>
                        <span className="caption">Выдано микроаймов</span>
                        <p>НДС</p>
                      </td>
                      <td>
                        <span className="caption">Просрочки</span>
                        <p>Проценты по микрозайму</p>
                      </td>
                      <td>
                        <span className="caption">Просрочки</span>
                        <p>НДС</p>
                      </td>
                      <td>
                        <span className="caption">Продление</span>
                        <p>Проценты по микрозайму</p>
                      </td>
                      <td>
                        <span className="caption">Продление</span>
                        <p>НДС</p>
                      </td>
                      <td>
                        <span className="caption">Перерасчёт</span>
                        <p>Проценты по микрозайму</p>
                      </td>
                      <td>
                        <span className="caption">Перерасчёт</span>
                        <p>НДС</p>
                      </td>
                      <td>
                        <span className="caption">Сторно при выкупе</span>
                        <p>Проценты по микрозайму</p>
                      </td>
                      <td>
                        <span className="caption">Сторно при выкупе</span>
                        <p>НДС</p>
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>
                        <span className="text-muted">Итого</span>
                      </td>
                      <td>
                        <span className="caption">Выдано микроаймов</span><p>0.00 BYN</p>
                      </td>
                      <td>
                        <span className="caption">Выдано микроаймов</span><p>0.00 BYN</p>
                      </td>
                      <td>
                        <span className="caption">Просрочки</span><p>0.00 BYN</p>
                      </td>
                      <td>
                        <span className="caption">Просрочки</span><p>0.00 BYN</p>
                      </td>
                      <td>
                        <span className="caption">Продление</span><p>0.00 BYN</p>
                      </td>
                      <td>
                        <span className="caption">Продление</span><p>0.00 BYN</p>
                      </td>
                      <td>
                        <span className="caption">Перерасчёт</span><p>0.00 BYN</p>
                      </td>
                      <td>
                        <span className="caption">Перерасчёт</span><p>0.00 BYN</p>
                      </td>
                      <td>
                        <span className="caption">Сторно при выкупе</span><p>0.00 BYN</p>
                      </td>
                      <td>
                        <span className="caption">Сторно при выкупе</span><p>0.00 BYN</p>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="11">
                        <span className="text-muted">Доход процентов по микрозайму</span>
                      </td>
                      <td>
                        <span className="caption">Сторно при выкупе</span><p>0.00 BYN</p>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="11">
                        <span className="text-muted">Доход НДС</span>
                      </td>
                      <td>
                        <span className="caption">Сторно при выкупе</span><p>0.00 BYN</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </TabPanel>
            <TabPanel>
            <div className="content-datatable-content p-l-spacer-2 p-r-spacer-2">
                <table className="table hover">
                  <thead>
                    <tr>
                      <th colSpan="2"></th>
                      <th scope="col" colSpan="2">Выдано микроаймов</th>
                      <th scope="col" colSpan="2">Просрочки</th>
                      <th scope="col" colSpan="2">Продление</th>
                      <th scope="col" colSpan="2">Перерасчёт</th>
                      <th scope="col" colSpan="2">Сторно при выкупе</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <span className="text-muted">№ П/П</span>
                      </td>
                      <td>
                        <span className="text-muted">Дата</span>
                      </td>
                      <td>
                        <span className="caption">Выдано микроаймов</span>
                        <p>Проценты по микрозайму</p>
                      </td>
                      <td>
                        <span className="caption">Выдано микроаймов</span>
                        <p>НДС</p>
                      </td>
                      <td>
                        <span className="caption">Просрочки</span>
                        <p>Проценты по микрозайму</p>
                      </td>
                      <td>
                        <span className="caption">Просрочки</span>
                        <p>НДС</p>
                      </td>
                      <td>
                        <span className="caption">Продление</span>
                        <p>Проценты по микрозайму</p>
                      </td>
                      <td>
                        <span className="caption">Продление</span>
                        <p>НДС</p>
                      </td>
                      <td>
                        <span className="caption">Перерасчёт</span>
                        <p>Проценты по микрозайму</p>
                      </td>
                      <td>
                        <span className="caption">Перерасчёт</span>
                        <p>НДС</p>
                      </td>
                      <td>
                        <span className="caption">Сторно при выкупе</span>
                        <p>Проценты по микрозайму</p>
                      </td>
                      <td>
                        <span className="caption">Сторно при выкупе</span>
                        <p>НДС</p>
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>
                        <span className="text-muted">Итого</span>
                      </td>
                      <td>
                        <span className="caption">Выдано микроаймов</span><p>0.00 BYN</p>
                      </td>
                      <td>
                        <span className="caption">Выдано микроаймов</span><p>0.00 BYN</p>
                      </td>
                      <td>
                        <span className="caption">Просрочки</span><p>0.00 BYN</p>
                      </td>
                      <td>
                        <span className="caption">Просрочки</span><p>0.00 BYN</p>
                      </td>
                      <td>
                        <span className="caption">Продление</span><p>0.00 BYN</p>
                      </td>
                      <td>
                        <span className="caption">Продление</span><p>0.00 BYN</p>
                      </td>
                      <td>
                        <span className="caption">Перерасчёт</span><p>0.00 BYN</p>
                      </td>
                      <td>
                        <span className="caption">Перерасчёт</span><p>0.00 BYN</p>
                      </td>
                      <td>
                        <span className="caption">Сторно при выкупе</span><p>0.00 BYN</p>
                      </td>
                      <td>
                        <span className="caption">Сторно при выкупе</span><p>0.00 BYN</p>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="11">
                        <span className="text-muted">Доход процентов по микрозайму</span>
                      </td>
                      <td>
                        <span className="caption">Сторно при выкупе</span><p>0.00 BYN</p>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="11">
                        <span className="text-muted">Доход НДС</span>
                      </td>
                      <td>
                        <span className="caption">Сторно при выкупе</span><p>0.00 BYN</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </TabPanel>
            <TabPanel>
            <div className="content-datatable-content p-l-spacer-2 p-r-spacer-2">
                <table className="table hover">
                  <thead>
                    <tr>
                      <th colSpan="2"></th>
                      <th scope="col" colSpan="2">Просрочки</th>
                      <th scope="col" colSpan="2">Продление</th>
                      <th scope="col" colSpan="2">Переасчёт</th>
                      <th scope="col" colSpan="2">Реализация</th>
                      <th scope="col" colSpan="2">Погашение</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <span className="text-muted">Подразделение</span>
                      </td>
                      <td>
                        <span className="text-muted">Тип залога</span>
                      </td>
                      <td>
                        <span className="caption">Просрочки</span>
                        <p>Проценты</p>
                      </td>
                      <td>
                        <span className="caption">Просрочки</span>
                        <p>НДС</p>
                      </td>
                      <td>
                        <span className="caption">Продление</span>
                        <p>Проценты</p>
                      </td>
                      <td>
                        <span className="caption">Продление</span>
                        <p>НДС</p>
                      </td>
                      <td>
                        <span className="caption">Переасчёт</span>
                        <p>Проценты</p>
                      </td>
                      <td>
                        <span className="caption">Переасчёт</span>
                        <p>НДС</p>
                      </td>
                      <td>
                        <span className="caption">Реализация</span>
                        <p>Проценты</p>
                      </td>
                      <td>
                        <span className="caption">Реализация</span>
                        <p>НДС</p>
                      </td>
                      <td>
                        <span className="caption">Погашение</span>
                        <p>Проценты</p>
                      </td>
                      <td>
                        <span className="caption">Погашение</span>
                        <p>НДС</p>
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>
                        <span className="text-muted">Итого по сети</span>
                      </td>
                      <td>
                        <span className="caption">Просрочки</span><p>0.00 BYN</p>
                      </td>
                      <td>
                        <span className="caption">Просрочки</span><p>0.00 BYN</p>
                      </td>
                      <td>
                        <span className="caption">Продление</span><p>0.00 BYN</p>
                      </td>
                      <td>
                        <span className="caption">Продление</span><p>0.00 BYN</p>
                      </td>
                      <td>
                        <span className="caption">Переасчёт</span><p>0.00 BYN</p>
                      </td>
                      <td>
                        <span className="caption">Переасчёт</span><p>0.00 BYN</p>
                      </td>
                      <td>
                        <span className="caption">Реализация</span><p>0.00 BYN</p>
                      </td>
                      <td>
                        <span className="caption">Реализация</span><p>0.00 BYN</p>
                      </td>
                      <td>
                        <span className="caption">Погашение</span><p>0.00 BYN</p>
                      </td>
                      <td>
                        <span className="caption">Погашение</span><p>0.00 BYN</p>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="11"></td>
                      <td>
                        <span className="caption">Погашение</span><p>0.00 BYN</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </TabPanel>
          </Tabs>
        </fieldset>
      </div>
    )
  }
}

export default ModalValIncomeContent;
